import { Injectable } from '@angular/core';
import { ApiBase } from './api.base';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CondicoesPagamentoApi extends ApiBase {

  constructor(http: HttpClient) {
    super(http, 'condicoes-pagamento');
  }
  
}
